/**
 * CSV template utilities for bulk user uploads in Admin Console
 */

interface CsvTemplateOptions {
  filename: string;
  headers: string[];
  exampleRows?: string[][];
}

/**
 * Generate and download a CSV template file
 */
export function downloadCsvTemplate(options: CsvTemplateOptions): void {
  const { filename, headers, exampleRows = [] } = options;

  // Create CSV content
  const headerRow = headers.join(",");
  const exampleRowsContent = exampleRows
    .map((row) => row.map(escapeCSVField).join(","))
    .join("\n");

  const csvContent = exampleRowsContent
    ? `${headerRow}\n${exampleRowsContent}`
    : headerRow;

  // Create blob and download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Escape CSV field values (handle commas, quotes, newlines)
 */
function escapeCSVField(field: string): string {
  if (field.includes(",") || field.includes('"') || field.includes("\n")) {
    return `"${field.replace(/"/g, '""')}"`;
  }
  return field;
}

/**
 * Download CSV template for bulk user upload
 * Includes example rows showing both learner and admin roles
 */
export function downloadBulkUserTemplate(): void {
  downloadCsvTemplate({
    filename: "bulk-users-template.csv",
    headers: ["email", "full_name", "role"],
    exampleRows: [
      ["learner@example.com", "John Learner", "learner"],
      ["admin@example.com", "Jane Admin", "admin"],
      ["another.user@example.com", "Another User", ""],
    ],
  });
}
